module.exports = __webpack_public_path__ + "static/media/fw-logo-dark-background.08c43656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/dist/images/fw-logo-dark-background.svg
// module id = 606
// module chunks = 0